import { autoinject } from 'aurelia-framework';
import { Sortable, SortableSortEvent } from '@shopify/draggable';
import { asyncUtil } from 'lib/helpers';
import {
  MooringProductionOrderStatusPipelineItem,
  UpdateMooringProductionOrderStatusContentQueueDto,
  UpdateMooringProductionOrderStatusContentQueueItem,
} from 'models/mooring/MooringProductionOrders';
import { MooringProductionOrderService } from 'services/mooring/mooring-production-order-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class BoardViewProduction {
  private mooringProductionOrderStatusPipelineItems: MooringProductionOrderStatusPipelineItem[] = [];

  private sortable: Sortable | null = null;

  constructor(
    private mooringProductionOrderService: MooringProductionOrderService,
    private toastService: ToastService
  ) {}

  protected async attached() {
    const response = await this.mooringProductionOrderService.getBoardData();
    this.mooringProductionOrderStatusPipelineItems = response.data;

    await this.setupSortable();
  }

  private async setupSortable() {
    // Wait for the DOM to be ready before initializing Sortable
    await asyncUtil.wait(200);

    this.sortable?.destroy?.();
    this.sortable = new Sortable(document.querySelectorAll('[sortable]'), {
      draggable: '[sortitem]',
      distance: 35,
    });

    this.sortable.on('sortable:stop', async (event: SortableSortEvent) => {
      try {
        // Ensure DOM is updated before proceeding
        await asyncUtil.wait(200);

        const orderId = event.dragEvent.source.children[0]?.attributes['data-id']?.value;
        if (!orderId) {
          this.toastService.showError('Order ID is invalid. Cannot update.');
          return;
        }

        const container = event.newContainer;
        const statusId = +(container.id || null);
        const orderElementsInQueye = Array.from(container.querySelectorAll('[sortitem]'));

        const dto = new UpdateMooringProductionOrderStatusContentQueueDto();
        dto.MooringProductionOrders = [];

        let sortIndex = 0;
        orderElementsInQueye.forEach((element) => {
          sortIndex++;
          const orderId = +element.children[0].attributes['data-id'].value;

          const update = new UpdateMooringProductionOrderStatusContentQueueItem();
          update.MooringProductionOrderId = orderId;
          update.SortIndex = sortIndex;

          dto.MooringProductionOrders.push(update);
        });

        await this.mooringProductionOrderService.updateBoardDataPipelineContent(statusId, dto);
        this.toastService.showSuccess('order.updated');
      } catch (error) {
        this.toastService.showError('An error occurred while updating the order queue.');
      }
    });
  }
}
